import {useState, useRef, useEffect} from "react";
import Form, {
    ButtonItem,
    GroupItem,
    RequiredRule,
    SimpleItem,
    AsyncRule,
    PatternRule,
    EmailRule,
} from "devextreme-react/form";
import {useSnackbar} from "notistack";
import {ErrorMessage, NotiStackInfo} from "../../../../palette/NotiStackInfo";
import {Layout, LayoutChild} from "../../../../palette/Palette";
import {buttonSuccess} from "../../../../utils/ComponentsSetting";
import {Button} from "devextreme-react/button";
import VerticalSpace from "../../../../palette/VerticalSpace";
import Alerts from "../../../../palette/Alerts";
import Avatar from '@material-ui/core/Avatar';
import PersonIcon from '@material-ui/icons/Person';
import {makeStyles} from '@material-ui/core/styles';
import FileUploader from 'devextreme-react/file-uploader';
import {storage} from '../../../../firebase/Firebase';
import {Filters} from '../../../../utils/HelpFunctions';
import ProgressLabel from "../../../../palette/Progress";
import {cities, namesControl, onlyLetters} from '../../../../utils/Utils';
import isAfter from 'date-fns/isAfter'
import TextBox from 'devextreme-react/text-box';
import {fastScrollTo, customScroll} from "../../../../utils/Scroll";
import {Element} from 'react-scroll'
import Text from "../../../../palette/Text";
import {asyncPhoneValidation, asyncValidation} from "../../../../utils/Validations";
import SelectBox from "devextreme-react/select-box";

const dataDriver = {
    profilePhoto: '',
    name: '',
    lastName: '',
    email: '',
    contactNumber: '',
    city: '',
    birthdate: '',
    idUser: '',
    address: '',
    tokenPush: '',
    typeLicense: '',
    dateExpiry: '',
    password: '',
    state: '',
    documentType: '',
};

const state = [{ID: 1, state: 'Activo'}, {ID: 2, state: 'Inactivo'}];

const typeLicense = ['A', ' B', ' F', 'A1', 'C', 'C1', 'D', 'D1', ' E', 'E1', 'G'];

const passwordOptions = {
    mode: 'password',
    disabled: true,
    value: '********',
};

const documents = [
    'Licencia',
    'Record policial',
];


function DriversForm(props) {

    const {DataStore, setVisibleForm, setVisibleGrid, dataDriversArray, storageID, setDataDrivers, dataDrivers} = props

    const {companyName, idCompany,} = DataStore

    const [submitButton] = useState({...buttonSuccess, text: ' Guardar y  continuar  '})
    const [progress, setProgress] = useState(0);
    const [progressImage, setProgressImage] = useState(0);
    const [filePhoto, setFilePhoto] = useState('No se ha selecionado ninguna imagen');
    const [isImage, setIsImage] = useState(true)
    const [imageAsUrl, setImageAsUrl] = useState(null);
    const [space, setSpace] = useState(false);
    const [documentType, setDocumentType] = useState('');
    const [documentTypeSelect, setDocumentTypeSelect] = useState(true);
    const [complete, setComplete] = useState(false)
    const [documentsLinks, setDocumentsLinks] = useState([]);
    const [document, setDocument] = useState('No se ha seleccionado ningún documento');
    const [validDocument, setValidDocument] = useState(true)
    const [alerts, setAlerts] = useState(false);
    const [enabledDocument, setEnabledDocument] = useState(true);

    const {enqueueSnackbar} = useSnackbar();
    const dxForm = useRef(null);
    const classes = useStyles();

    useEffect(() => {
        const {instance} = dxForm.current;
        instance.resetValues();

    }, [storageID])

    const renderCancelButton = () => {
        const {instance} = dxForm.current
        return (
            <Layout row positionL>
                <Button id="cancel-button"
                        icon="fas fa-ban"
                        text="Cancelar"
                        onClick={() => {
                            instance.resetValues()
                            setVisibleForm(false)
                            setVisibleGrid(true)
                        }}/>
            </Layout>
        )
    }

    const spaceRender = () => {
        return (
            <div>
                {space &&
                <span style={{fontSize: 12, color: 'red'}}>El correo electrónico contiene espacios en blanco</span>}
            </div>
        );
    };

    const onSelectedImageFilesChanged = (e) => {

        const arrayExt = ['jpg', 'jpeg', 'png'];
        const extension = e.value[0].name.split('.').pop();
        const found = arrayExt.find(element => element === extension);

        if (found) {
            const picName = `${e.value[0].name}`;
            const bucketPath = `${companyName}/drivers/${storageID}/${picName}`;
            setFilePhoto(`${e.value[0].name}`);

            const storageRef = storage.ref(bucketPath);
            const task = storageRef.put(e.value[0]);

            task.on('state_changed', (snapshot) => {
                let percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                setProgressImage(percentage)
                setFilePhoto(`${e.value[0].name} ${percentage} %`);
            }, () => {
                NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar);
            }, () => {

                storage.ref(`${companyName}/drivers/${storageID}/`).child(picName).getDownloadURL()
                    .then(async fireBaseUrl => {
                        setImageAsUrl(fireBaseUrl);
                        setFilePhoto('Imagen cargada...');
                        setProgressImage(0);
                        setAlerts(false)
                        customScroll('document-element', 500)
                    });
            });
        } else {
            setIsImage(false);
        }
    };
    const photoRender = () => {
        return (
            <Layout color="transparent" positionR center>
                {imageAsUrl ? <Avatar alt="" src={imageAsUrl} className={classes.large}/> :
                    <Avatar alt="" className={classes.large}>
                        <PersonIcon/>
                    </Avatar>
                }
            </Layout>
        );
    };
    const uploadPhoto = () => {
        return (
            <Layout color={'transparent'}>
                <Layout color={'transparent'} center row positionL>
                    <LayoutChild color={'transparent'} center row width="auto">
                        <FileUploader multiple={false} accept={'*'} uploadMode={'instantly'} showFileList={false}
                                      allowedFileExtensions={['.jpg', '.jpeg', '.gif', '.png']}
                                      inputAttr={{id: 'upload-buttons'}} selectButtonText={'Seleccionar imagen'}
                                      onValueChanged={onSelectedImageFilesChanged}
                                      disabled={complete}
                                      labelText={filePhoto}/>
                    </LayoutChild>

                </Layout>
                {progressImage > 0 &&
                <Layout color={'#FFF'}>
                    <ProgressLabel progress={progressImage}/>
                </Layout>
                }
                {!isImage && <Alerts severity={'warning'} body={'Solo se permiten imágenes'}/>}
            </Layout>
        );
    };

    const onFocusOut = () => {
        if (documentType === '') {
            setEnabledDocument(true)
            setDocumentTypeSelect(false)
        } else {
            setEnabledDocument(false)
            setDocumentTypeSelect(true)
        }
        fastScrollTo('document-element')
    }

    const onFocusIn = () => {
        setEnabledDocument(false)
        fastScrollTo('document-element')
    }

    const onChangedDocument = (e) => {
        setDocumentType(e.value);

    };
    const documentRender = () => {
        return (
            <>

                <Layout row center space>
                    <div style={{height: 75, width: '49%'}}>
                        <div style={{height: 15}}/>
                        <SelectBox items={documents}
                                   value={documentType}
                                   disabled={complete}
                                   onValueChanged={onChangedDocument}
                        />
                    </div>
                    <LayoutChild percent={49} center positioonR le>
                        <LayoutChild center positionR>
                            <FileUploader multiple={false} accept={'*'} uploadMode={'instantly'}
                                          disabled={documentType === ''}
                                          selectButtonText={'Seleccionar el tipo de documento'} showFileList={false}
                                          onValueChanged={onSelectedDocumentChanged}
                                          labelText={document}/>
                            {progress > 0 && <ProgressLabel progress={progress}/>}
                        </LayoutChild>
                    </LayoutChild>
                </Layout>
                <VerticalSpace space={5}/>
                <Element name="document-element" className="element"/>
                {!documentTypeSelect && <Alerts severity={'warning'} body='Ingrese el tipo de documento'/>}
                <VerticalSpace space={2}/>
                {!validDocument && <Alerts severity={'error'}
                                           body='Archivo invalido, solo se permiten archivos con extensión jpg, jpeg, png, doc, pdf, docx'/>}
                <VerticalSpace space={2}/>
                {alerts &&
                <Alerts severity="error" body={'¡La imagen de perfil o ducumentos aun no ha sido cargados!'}/>}

                {/*<Layout row center space>
                    <div style={{height: 75, width: '49%'}}>
                        <Layout row center space>
                            <div style={{marginRight: 25}}>Tipo de documento*</div>
                            <div style={{width: '70%'}}>
                                <TextBox value={documentType} onValueChanged={onChangedDocument} onFocusIn={onFocusIn}
                                         onFocusOut={onFocusOut}/>
                                {(complete && progress === 0) &&
                                <Text hover={false} text={'Carga completa. Desea selecionar otro documento ?'}
                                      weight={'700'} size={10} color={'green'}/>
                                }
                            </div>
                        </Layout>
                        <VerticalSpace space={5}/>
                    </div>
                    <LayoutChild percent={49} center positioonR le>
                        <LayoutChild center positionR>
                            <FileUploader multiple={false} accept={'*'} uploadMode={'instantly'}
                                          disabled={enabledDocument}
                                          selectButtonText={'Seleccionar el tipo de documento'} showFileList={false}
                                          onValueChanged={onSelectedDocumentChanged}
                                          labelText={document}/>
                            {progress > 0 && <ProgressLabel progress={progress}/>}
                        </LayoutChild>
                    </LayoutChild>
                </Layout>
                <VerticalSpace space={5}/>
                <Element name="document-element" className="element"/>
                {!documentTypeSelect && <Alerts severity={'warning'} body='Ingrese el tipo de documento'/>}
                <VerticalSpace space={2}/>
                {!validDocument && <Alerts severity={'error'}
                                           body='Archivo invalido, solo se permiten archivos con extensión jpg, jpeg, png, doc, pdf, docx'/>}
                <VerticalSpace space={2}/>
                {alerts &&
                <Alerts severity="error" body={'¡La imagen de perfil o ducumentos aun no han sido cargados!'}/>}*/}
            </>
        )

    };
    const onSelectedDocumentChanged = (e) => {

        const arrayExt = ['jpg', 'jpeg', 'png', 'doc', 'pdf', 'docx'];
        const extension = e.value[0].name.split('.').pop();
        const found = arrayExt.find(element => element === extension);

        fastScrollTo('document-element')

        if (e.value[0].name !== '' && documentType !== '') {

            if (found) {
                setValidDocument(true)
                setDocumentTypeSelect(true)
                setDocument(`${e.value[0].name}`);
                const bucketPath = `${companyName}/drivers/${storageID}/${e.value[0].name}`;
                const storageRef = storage.ref(bucketPath);
                const task = storageRef.put(e.value[0]);

                const dataArray = [...documentsLinks];
                const dataObject = {};
                fastScrollTo('document-element')

                task.on('state_changed', (snapshot) => {
                    let percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    setDocument(`Cargando  ${e.value[0].name}`);
                    setProgress(percentage)
                    fastScrollTo('document-element')
                }, () => {
                    NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar);
                }, () => {

                    storage.ref(`${companyName}/drivers/${storageID}/`).child(e.value[0].name).getDownloadURL()
                        .then(async fireBaseUrl => {
                            dataObject.url = fireBaseUrl;
                            dataObject.name = documentType;
                            dataObject.bucketPath = bucketPath;
                            dataArray.push(dataObject);
                            setProgress(0)
                            setDocument(e.value[0].name);
                            fastScrollTo('document-element')
                            setEnabledDocument(true)
                            setDocumentType('')
                            setAlerts(false)
                        });
                });
                setDocumentsLinks(dataArray);
            } else {
                setDocumentTypeSelect(true)
                setValidDocument(false)
                fastScrollTo('document-element')
            }
        } else {
            setDocumentTypeSelect(false)
            fastScrollTo('document-element')
        }
    };


    function sendRequest(value) {
        const resultArray = Filters(dataDriversArray, 'idUser', value);
        if (resultArray.length > 0) {
            return new Promise((resolve) => {
                setTimeout(function () {
                    resolve(false);
                }, 500);
            });
        } else {
            return new Promise((resolve) => {
                setTimeout(function () {
                    resolve(true);
                }, 500);
            });
        }
    }

    function asyncValidationDriver(params) {
        return sendRequest(params.value);
    }

    function sendRequestPhone(value) {
        const resultArray = Filters(dataDriversArray, 'contactNumber', value);
        if (resultArray.length > 0) {
            return new Promise((resolve) => {
                setTimeout(function () {
                    resolve(false);
                }, 500);
            });
        } else {
            return new Promise((resolve) => {
                setTimeout(function () {
                    resolve(true);
                }, 500);
            });
        }
    }

    function asyncValidationPhone(params) {
        return sendRequestPhone(params.value);
    }

    function sendRequestLicense(value) {
        let result = isAfter(new Date(), value)
        if (result) {
            return new Promise((resolve) => {
                setTimeout(function () {
                    resolve(false);
                }, 1000);
            });
        } else {
            return new Promise((resolve) => {
                setTimeout(function () {
                    resolve(true);
                }, 1000);
            });
        }
    }

    function asyncValidationLicense(params) {
        return sendRequestLicense(params.value);
    }

    function sendRequestEmail(value) {
        const resultArray = Filters(dataDriversArray, 'email', value);

        const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$/;
        emailPattern.test(value);


        if (resultArray.length > 0) {
            return new Promise((resolve) => {
                setTimeout(function () {
                    resolve(false);
                }, 500);
            });
        } else {
            return new Promise((resolve) => {
                setTimeout(function () {
                    resolve(true);
                }, 500);
            });
        }
    }

    const asyncValidationEmail = async (params) => {
        return sendRequestEmail(params.value)
    }

    const onValueChanged = () => {
        const str = dataDriver.email;
        if (str.indexOf(' ') >= 0) {
            setSpace(true);
        } else {
            setSpace(false);
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (imageAsUrl && documentsLinks.length > 0) {
            const data = {
                ...dataDriver,
                profilePhoto: imageAsUrl,
                documents: documentsLinks,
                companyName: companyName,
                idCompany: idCompany,
                accessSystem: false,
            };
            setDataDrivers(data)
            setComplete(true)
        } else {
            setAlerts(true);
        }
    }

    return (
        <>
            <form action="" onSubmit={handleSubmit}>
                <Form
                    ref={dxForm}
                    formData={dataDriver}
                    readOnly={false}
                    showColonAfterLabel={true}
                    showValidationSummary={true}
                    validationGroup="form-drivers"
                >
                    <GroupItem caption="Foto de perfil" colCount={2}>
                        <SimpleItem render={photoRender}/>
                        <SimpleItem render={uploadPhoto}/>
                    </GroupItem>
                    <GroupItem caption={'Datos del conductor'} colCount={dataDrivers ? 1 : 2}>
                        <SimpleItem dataField="name" label={{text: 'Nombres'}}
                                    editorOptions={{maxLength: 25, disabled: complete}}>
                            <RequiredRule message="Ingrese el nombre"/>
                            <PatternRule message="Solo se permiten letras." pattern={namesControl}/>
                        </SimpleItem>

                        <SimpleItem dataField="lastName" label={{text: 'Apellidos'}}
                                    editorOptions={{maxLength: 25, disabled: complete}}>
                            <RequiredRule message="Ingrese el apellido"/>
                            <PatternRule message="Solo se permiten letras." pattern={namesControl}/>
                        </SimpleItem>

                        <SimpleItem dataField="idUser" label={{text: 'Cédula/Pasaporte'}}
                                    editorOptions={{maxLength: 20, disabled: complete}}>
                            <RequiredRule message="Ingrese su numero de identificacion"/>
                            <AsyncRule
                                message="Conductor ya registrado"
                                validationCallback={asyncValidationDriver}/>
                        </SimpleItem>

                        <SimpleItem dataField="email" label={{text: 'Correo electrónico'}}
                                    editorOptions={{onValueChanged: onValueChanged, maxLength: 70, disabled: complete}}>
                            <EmailRule message="Correo electrónico inválido"/>
                            <RequiredRule message="Ingrese el correo electrónico del conductor"/>
                            <AsyncRule
                                message={'Este correo electrónico ya a sido registrado'}
                                validationCallback={asyncValidationEmail}/>
                            <AsyncRule
                                message="Correo electrónico inválido"
                                validationCallback={asyncValidation}/>
                        </SimpleItem>

                        <SimpleItem dataField="contactNumber" label={{text: 'Núm. de contacto'}}
                                    editorOptions={{maxLength: 20, disabled: complete}}>
                            <RequiredRule message="Ingrese el número de contacto"/>
                            <PatternRule message="Ingresar solo números" pattern={/^[0-9]+$/}/>
                            <AsyncRule
                                message="Este número de telefono ya ha sido registrado"
                                validationCallback={asyncValidationPhone}/>
                            <AsyncRule
                                message="Este número de telefono incorrecto"
                                validationCallback={asyncPhoneValidation}/>
                        </SimpleItem>

                        <SimpleItem dataField="city" label={{text: 'Ciudad'}} editorType="dxSelectBox"
                                    editorOptions={{
                                        items: cities,
                                        searchEnabled: true,
                                        disabled: complete,
                                        placeholder: 'Seleccionar...',
                                    }}>
                            <RequiredRule message="Seleccione la ciudad"/>
                        </SimpleItem>

                        <SimpleItem dataField="birthdate" label={{text: 'Fecha de nacimiento'}}
                                    editorType="dxDateBox" editorOptions={{disabled: complete}}>
                            <RequiredRule message="Ingrese la fecha de nacimiento"/>
                        </SimpleItem>


                        <SimpleItem dataField="address" label={{text: 'Dirección'}}
                                    editorOptions={{maxLength: 50, disabled: complete}}>
                            <RequiredRule message="Ingrese la dirección"/>
                        </SimpleItem>

                        <SimpleItem dataField="typeLicense" label={{text: 'Tipos de licencia'}}
                                    editorType="dxSelectBox"
                                    editorOptions={{
                                        items: typeLicense,
                                        searchEnabled: true,
                                        placeholder: 'Seleccionar...',
                                        disabled: complete
                                    }}>
                            <RequiredRule message="Seleccione el tipo de licencia"/>
                        </SimpleItem>

                        <SimpleItem dataField="dateExpiry" label={{text: 'Fecha de caducidad'}}
                                    editorType="dxDateBox" editorOptions={{min: new Date(), disabled: complete}}
                        >
                            <RequiredRule message="Ingrese la fecha de expiración"/>
                            <AsyncRule
                                message="No se puede ingresar una licencia caducada"
                                validationCallback={asyncValidationLicense}/>
                        </SimpleItem>

                        <SimpleItem dataField="password" label={{text: 'Contraseña'}}
                                    editorOptions={passwordOptions}>
                            <RequiredRule message="Ingrese la nueva contraseña"/>
                        </SimpleItem>

                        <SimpleItem dataField="state" label={{text: 'Estado'}} editorType="dxSelectBox"
                                    editorOptions={{
                                        dataSource: state,
                                        displayExpr: 'state',
                                        valueExpr: 'state',
                                        searchEnabled: true,
                                        placeholder: 'Seleccionar...',
                                        disabled: complete
                                    }}>
                            <RequiredRule message="Seleccione el estado"/>
                        </SimpleItem>
                    </GroupItem>
                    <GroupItem caption="Documentos" colCount={1}>
                        <SimpleItem render={documentRender}/>
                    </GroupItem>
                    <GroupItem colCount={1}>
                        <SimpleItem render={spaceRender}/>
                    </GroupItem>
                    {dataDrivers ? null :
                        <GroupItem colCount={2}>
                            <SimpleItem render={renderCancelButton} horizontalAlignment="right"/>
                            <ButtonItem horizontalAlignment="right" buttonOptions={submitButton}/>
                        </GroupItem>}
                </Form>
                <Element name="bottom-element" className="element"/>
            </form>
        </>
    )
}

export default DriversForm

const useStyles = makeStyles((theme) => ({
        root: {
            width: '100%',
            '& > * + *': {
                marginTop: theme.spacing(2),
            }
        }
        ,
        large:
            {
                width: theme.spacing(10),
                height: theme.spacing(10),
            },
    }
));
